import { ApiApp } from './config';

/**
 * Generate a client-side proxy URL for use in browser `fetch` calls.
 * Routes through the Next.js proxy at /api/proxy, which attaches the JWT from the session cookie.
 *
 * @example proxy('smsinbox', '/api/service') => '/api/proxy/smsinbox/api/service'
 */
export function proxy(application: ApiApp, path: string): string {
  if (path.startsWith('/')) {
    path = path.slice(1);
  }

  return `/api/proxy/${application}/${path}`;
}

const MAX_CONCURRENT = 3;
let active = 0;
const queue: (() => void)[] = [];

/**
 * The Queued Fetch is used for areas where lots of API calls are made concurrently.
 * The browser has a limit to the number of concurrent API calls so without this,
 * other parts of the application becomes unresponsive while they load.
 * Right now, this is primarly used for the Dashboard cards.
 */
export function queuedFetch(url: string, options?: RequestInit): Promise<Response> {
  return new Promise((resolve, reject) => {
    const run = () => {
      active++;
      fetch(url, options)
        .then(resolve, reject)
        .finally(() => {
          active--;
          queue.shift()?.();
        });
    };
    if (active < MAX_CONCURRENT) {
      run();
    } else {
      queue.push(run);
    }
  });
}
